import{T as t,d as o}from"./theme-button2.js";const s=t,e=o;export{s as ThemeButton,e as defineCustomElement}